import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FooterComponent } from '@pacifico/components/footer/footer.component';
import { HeaderComponent } from '@pacifico/components/header/header.component';
import { LoaderComponent } from '@pacifico/components/loader/loader.component';

@NgModule({
	declarations: [HeaderComponent, FooterComponent, LoaderComponent],
	imports: [CommonModule],
	exports: [HeaderComponent, FooterComponent, CommonModule, LoaderComponent]
})
export class SharedHeaderFooterModule {}
